import { useEffect } from "react";

const SITE = "GameRealm";
const BASE = "https://gamerealm.org";
const DEFAULT_DESC = "Buy cheap Steam, Rockstar and Xbox game activation keys with USDT (TRC20, ERC20, SOL, BEP20). 1,500+ titles, mystery boxes and weekly deals. Keys delivered by email.";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

export const useSEO = ({ title, description = DEFAULT_DESC, path, image = "https://gamerealm.org/og-image.jpg" } = {}) => {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} — Cheap Game Keys, Pay with USDT`;
    const url = `${BASE}${path ?? window.location.pathname}`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    if (image) { setMeta("property", "og:image", image); setMeta("name", "twitter:image", image); }
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
  }, [title, description, path, image]);
};
